export default __webpack_public_path__ + "static/media/Gallery-13.739f87e8.jpeg";